import React, { ChangeEvent, FocusEvent } from 'react';

import './CustomValidity.scss';

interface Props {
  label: string;
  width?: string | number;
  valueMonthly?: string | number | undefined;
  valueFiveYearly?: string | number | undefined;
  disabledFiveYearly?: boolean;
  disabledMonthly?: boolean;
  showCheckbox?: boolean;
  onChangeMonthly?: (e: ChangeEvent<HTMLSelectElement>) => void;
  onChangeFiveYearly?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlurMonthly?: (e: FocusEvent<HTMLSelectElement>) => void;
  onBlurFiveYearly?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const CustomValidity = ({
  label,
  width,
  valueFiveYearly,
  valueMonthly,
  disabledFiveYearly,
  disabledMonthly,
  showCheckbox,
  onChangeFiveYearly,
  onChangeMonthly,
  onBlurFiveYearly,
  onBlurMonthly,
}: Props) => {
  return (
    <div className="custom-validity-container">
      <div className="label-box">
        <p className="label__text">{label}</p>
      </div>
      <div style={{ width }} className="custom-validity-checkbox-container">
        <select
          id="monthly"
          name="monthly"
          className="generate-pdf__select"
          value={valueMonthly}
          disabled={disabledMonthly}
          onChange={onChangeMonthly}
          onBlur={onBlurMonthly}
        >
          {valueFiveYearly && <option value="">5 years</option>}
          <option value="0">0 Month</option>
          <option value="1">1 Month</option>
          <option value="2">2 Month</option>
          <option value="3">3 Month</option>
          <option value="4">4 Month</option>
          <option value="5">5 Month</option>
          <option value="6">6 Month</option>
          <option value="7">7 Month</option>
          <option value="8">8 Month</option>
          <option value="9">9 Month</option>
          <option value="10">10 Month</option>
          <option value="11">11 Month</option>
          <option value="12">12 Month</option>
        </select>

        {showCheckbox && <label htmlFor="monthly">or</label>}

        {showCheckbox && (
          <input
            id="fiveYearly"
            name="fiveYearly"
            className="custom-validity-checkbox"
            type="checkbox"
            value={valueFiveYearly}
            disabled={disabledFiveYearly}
            onChange={onChangeFiveYearly}
            checked={!!valueFiveYearly}
            onBlur={onBlurFiveYearly}
          />
        )}
        {showCheckbox && <label htmlFor="fiveYearly">5 years?</label>}
      </div>
    </div>
  );
};
